import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDemographics = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 12c2.762 0 5-2.238 5-5 0-2.763-2.238-5-5-5S7 4.237 7 7c0 2.762 2.238 5 5 5Zm0 2.5c-3.338 0-10 1.675-10 5v1.25c0 .688.563 1.25 1.25 1.25h17.5c.688 0 1.25-.563 1.25-1.25V19.5c0-3.325-6.662-5-10-5Z",
		fill: "currentColor"
	})
});
export default SvgDemographics;
